import { View } from "extensions/marionette";

import controlsTemplate from "./controls.jst";

export const Controls = View.extend({
    template: controlsTemplate,
    ui: {
        clearBar: ".clear-bar",
        toggleMode: ".switch-mode"
    },
    events: {
        "click @ui.toggleMode": function(e) {
            e.preventDefault();
            if (!this.ui.toggleMode.hasClass("disabled")) {
                this.setMode(this.state.mode === "token" ? "text" : "token");
            }
        }
    },

    triggers: {
        "click .text-apply": "apply",
        "click .clear-bar": "clear",
        "click .save-filter": "save:filters"
    },
    
    initialize() {
        this.state = {
            mode: this.getOption("mode"),
            tempTokensPresent: false,
            showClearIcon: false,
            showSaveIcon: false,
            savedFilter: typeof this.getOption("savedFilter") !== "undefined"
        };
    },

    setMode(mode, { silent = false } = {}) {
        this.state.mode = mode;
        
        if (!silent) {
            this.triggerMethod("mode:change", this.state.mode);
        }
        
        this.render();
    },
    
    setClearVisibility({ show }) {
        // Right now both clear icon and save filter icon are displayed when there are tokens in the input
        this.state.showClearIcon = show;
        this.state.showSaveIcon = show && this.getOption("hasSavedFilters");
        this.render();
    },
    
    toggleTempModeState(tempTokensPresent) {
        this.state.tempTokensPresent = tempTokensPresent;
        this.render();
    },
    
    templateContext() {
        return {
            state: this.state
        };
    }
});
